import React, { memo } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import { RULE_ACTION_OPTIONS } from 'apps/spot-quote-control-panel/constants/spotBiddingConfig'
import {
  ISpotBiddingRule,
  RULE_ACTION,
  SPOT_PREMIUM_TYPE,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

interface IRuleOptionProps {
  value: RecursivePartial<ISpotBiddingRule>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
}

export const RuleOption = memo<IRuleOptionProps>(({ onChange, value }) => {
  const { ruleAction } = value

  const ruleTypeHandler = (e: ISelectOption) => {
    onChange({
      ruleAction: e.value as RULE_ACTION,
      spotPremium:
        e.value === RULE_ACTION.applyPremium
          ? {
              premiumType: SPOT_PREMIUM_TYPE.percentage,
              amount: '',
            }
          : undefined,
    })
  }

  return (
    <div className='col-md-6 col-xs-4'>
      <Select
        label='Rule Option'
        placeholder='Choose an option'
        options={RULE_ACTION_OPTIONS}
        value={ruleAction}
        onChange={ruleTypeHandler}
        dataTest='modal-rule-option'
        required
        large
      />
    </div>
  )
})
